import { Mutation } from "@apollo/client/react/components";
import React from "react";
import getTargetType from "~/lib/mutations/getTargetType";
import SetProfileCoverMutation from "~/lib/mutations/SetProfileCoverMutation";
import {
  ISetProfileCoverMutation as ISetProfileCoverMutationDefintion,
  ISetProfileCoverMutationVariables,
} from "~/lib/mutations/__generated__/SetProfileCoverMutation.generated";

interface ISetProfileCoverProps {
  entityType: "Government" | "Company" | "VendorUser" | "GovernmentUser" | "PendingUser";
  targetId: string;
  children: (setProfileCover: ISetProfileCover) => any;
}

interface ISetProfileCover {
  onSetProfileCover: (originalSource: string) => any;
  onSetRepositionedCover: (originalSource: string, repositionedSource: any, repositionState: any) => any;
  onRemoveCover: () => any;
}

const SetProfileCover: React.FunctionComponent<ISetProfileCoverProps> = ({ entityType, targetId, children }) => {
  return (
    <Mutation<ISetProfileCoverMutationDefintion, ISetProfileCoverMutationVariables> mutation={SetProfileCoverMutation}>
      {(setProfileCover) =>
        children({
          onSetProfileCover: (originalSource) => {
            setProfileCover({
              variables: {
                targetId,
                targetType: getTargetType(entityType) as any,
                cover: {
                  original: originalSource,
                  repositioned: null,
                  reposition: null,
                },
              },
              optimisticResponse: {
                __typename: "Mutation",
                setProfileCover: {
                  __typename: entityType as any,
                  _id: targetId,
                  cover: {
                    __typename: "Cover",
                    original: originalSource,
                    repositioned: null,
                  },
                },
              },
            });
          },
          onSetRepositionedCover: (originalSource, repositionedSource, repositionState) => {
            setProfileCover({
              variables: {
                targetId,
                targetType: getTargetType(entityType) as any,
                cover: {
                  original: originalSource,
                  repositioned: repositionedSource,
                  reposition: repositionState,
                },
              },
              optimisticResponse: {
                __typename: "Mutation",
                setProfileCover: {
                  __typename: entityType as any,
                  _id: targetId,
                  cover: {
                    __typename: "Cover",
                    original: originalSource,
                    repositioned: repositionedSource,
                  },
                },
              },
            });
          },
          onRemoveCover: () =>
            setProfileCover({
              variables: {
                targetId,
                targetType: getTargetType(entityType) as any,
                cover: null,
              },
              optimisticResponse: {
                __typename: "Mutation",
                setProfileCover: {
                  __typename: entityType as any,
                  _id: targetId,
                  cover: {
                    __typename: "Cover",
                    original: null,
                    repositioned: null,
                  },
                },
              },
            }),
        })
      }
    </Mutation>
  );
};

export default SetProfileCover;
